import React from "react";
import {ValidatedValue} from "../../../../helpers/validatedValue";
import {OwnVehicleToAssignModel} from "../../../../vehicleAssigment/models/vehicleAssigment";
import {RadioModel}  from "../../../models/radio";
import RadioGroup from "../radioGroup/radioGroup";

interface SelectOwnedVehicleFormProps {
    ownedVehicles: OwnVehicleToAssignModel[];
    selectedOwnVehicle: ValidatedValue<null | string>;
}

export default function SelectOwnedVehicleForm(props: SelectOwnedVehicleFormProps) {
    return (
        <div className="select-owned-vehicle-form">
            <RadioGroup
                testId="owned-vehicles"
                label=""
                items={getOwnedVehicle()}
                validatedValue={props.selectedOwnVehicle}
            />
        </div>
    );

    function getOwnedVehicle(): RadioModel[] {
        if (props.ownedVehicles && props.ownedVehicles.length > 0) {
            const table = props.ownedVehicles.map((own) => {
                return {
                    value: own.id,
                    label: own.licencePlate
                } as RadioModel;
            });

            return table;
        }

        return [{value: "", label: ""}];
    }
}